module.exports = "/packs/chevron-left-white-96fed8412a25f2ab2989f55db85fd100.svg";